export const DOCUMENT_VIEW_REQUEST = "Document.View.Request";
export const DOCUMENT_VIEW_SUCCESS = "Document.View.Success";
export const DOCUMENT_VIEW_FAILURE = "Document.View.Failure";

export function fetchDocument(id) {
  return (dispatch, getState) => {
    const { auth } = getState();
    dispatch({ type: DOCUMENT_VIEW_REQUEST });
    return fetch(`/api/documents/${id}`, {
      headers: {
        Authorization: `Bearer ${auth.token}`,
      },
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        dispatch({
          type: DOCUMENT_VIEW_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({
          type: DOCUMENT_VIEW_FAILURE,
          payload: data,
        });
      }
    });
  };
}
